export default __webpack_public_path__ + "static/media/rabbit-red.36584d2e.svg";